/**
 * Setup wave canvases
 */
import Gradient from '../vendor/stripe-gradient-animation'

export const addWaves = (els, color = 'blue') => {
	if (els) {
		els.forEach((el) => {
			const canvas = document.createElement('canvas')
			canvas.classList.add('waves', `waves--${color}`)
			el.appendChild(canvas)
		})
	}
}

export const setupWaves = (els) => {
	if (els) {
		els.forEach((el) => {
			const random = Math.floor(Math.random() * (10 - 2 + 1)) + 2
			const gradient = new Gradient({ amp: 0 })
			gradient.initGradient(el)
			gradient.amp = 200
			gradient.seed = random
		})
	}
}
